import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersonalFormData, BusinessFormData, RegistrationState } from '../types/registration.types';

const INACTIVITY_TIMEOUT = 30; // 30 minutes

const initialState: RegistrationState = {
  personal: {
    data: null,
    lastUpdated: 0
  },
  business: {
    data: null,
    lastUpdated: 0
  },
  sessionTimeout: INACTIVITY_TIMEOUT
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    updatePersonalForm: (state, action: PayloadAction<Partial<PersonalFormData>>) => {
      state.personal.data = {
        ...state.personal.data,
        ...action.payload
      } as PersonalFormData;
      state.personal.lastUpdated = Date.now();
    },
    updateBusinessForm: (state, action: PayloadAction<Partial<BusinessFormData>>) => {
      state.business.data = {
        ...state.business.data,
        ...action.payload
      } as BusinessFormData;
      state.business.lastUpdated = Date.now();
    },
    clearPersonalForm: (state) => {
      state.personal = initialState.personal;
    },
    clearBusinessForm: (state) => {
      state.business = initialState.business;
    },
    clearAllForms: () => initialState,
    checkSessionTimeout: (state) => {
      const now = Date.now();
      const personalTimeout = state.personal.lastUpdated + (state.sessionTimeout * 60 * 1000);
      const businessTimeout = state.business.lastUpdated + (state.sessionTimeout * 60 * 1000);

      if (state.personal.lastUpdated && now > personalTimeout) {
        state.personal = initialState.personal;
      }
      if (state.business.lastUpdated && now > businessTimeout) {
        state.business = initialState.business;
      }
    },
    setSessionTimeout: (state, action: PayloadAction<number>) => {
      state.sessionTimeout = action.payload;
    }
  }
});

export const {
  updatePersonalForm,
  updateBusinessForm,
  clearPersonalForm,
  clearBusinessForm,
  clearAllForms,
  checkSessionTimeout,
  setSessionTimeout
} = registrationSlice.actions;

export default registrationSlice.reducer; 